/** OpenLayers grid-system factory for WarOfficeCassini; the theatre data itself is ol-free in `WarOfficeCassini.ts`. */
import { WAR_OFFICE_CASSINI_SCHEME } from '../formatters/schemes.js';
import { createMBSGridSystem } from './shared.js';
import { WAR_OFFICE_CASSINI_CLIP_POLYGON, WAR_OFFICE_CASSINI_CRS, WAR_OFFICE_CASSINI_PROJ4, } from './WarOfficeCassini.js';
export function createWarOfficeCassiniGridSystem(options) {
    return createMBSGridSystem(WAR_OFFICE_CASSINI_CRS, WAR_OFFICE_CASSINI_PROJ4, WAR_OFFICE_CASSINI_SCHEME, WAR_OFFICE_CASSINI_CLIP_POLYGON, options);
}
//# sourceMappingURL=WarOfficeCassini.grid.js.map